// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__36dgo","inputWrap":"CustomTip_inputWrap__2bvCi"};